import { FC, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../../../components/Button';
import {
  saveEditedTimeline,
  saveReportForLater,
  setLogbookPage,
  useSaveEditedTimeline,
} from '../../../../services/logbook';
import { ReportFooter } from '../views';
import styles from './Timeline.module.css';
import { DisplayTimeline, EditButton, EditTimeline } from './views';

export const Timeline: FC = () => {
  const [edit, setEdit] = useState(false);
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const scrollPrcnt = useRef(0);
  useSaveEditedTimeline();

  useEffect(() => {
    if (ref) {
      ref.scrollTo({
        left:
          ((ref?.scrollWidth ?? 0) - (ref?.offsetWidth ?? 0)) *
          scrollPrcnt.current,
      });
    }
  }, [ref, edit]);

  return (
    <>
      <div
        className={styles.timelineContainer}
        ref={setRef}
        onScroll={(e) => {
          scrollPrcnt.current =
            e.currentTarget.scrollLeft /
            ((ref?.scrollWidth ?? 0) - (ref?.offsetWidth ?? 0));
        }}
      >
        {edit ? <EditTimeline /> : <DisplayTimeline />}
        {!edit && <EditButton onClick={() => setEdit(true)} />}
      </div>
      {!edit ? (
        <ReportFooter>
          <Button grow onClick={() => setLogbookPage(2)}>
            <FormattedMessage id="NextStep" />
          </Button>
          <Button variant="text" grow onClick={() => saveReportForLater()}>
            <FormattedMessage id="SaveForLater" />
          </Button>
        </ReportFooter>
      ) : (
        <ReportFooter>
          <Button
            grow
            onClick={() => {
              saveEditedTimeline();
              setEdit(false);
            }}
          >
            <FormattedMessage id="SaveUpdates" />
          </Button>
        </ReportFooter>
      )}
    </>
  );
};
